import React, { useRef, useState } from 'react';
import { v4 } from 'uuid';

import {
  Badge,
  Box,
  IconButton,
  InputAdornment,
  Popover,
  TableCell,
  TableSortLabel,
  TextField,
} from '@mui/material';
import { Check, Close, FilterAlt } from '@mui/icons-material';

const TableHeadCol = (props) => {
  const { onRequestSort, order, orderBy } = props;
  const { cell, filter, setFilter } = props;

  const ref = useRef(null);
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(filter);
  const [cellId] = useState(v4());

  const createSortHandler = (property) => (event) => onRequestSort(property, event);
  // const cellId = /* cell.id || */ v4();
  const cellName = cell.name || cellId;
  const tableCellProps = {
    key: cellId,
    align: cell.align || 'left',
    padding: cell.disablePadding ? 'none' : 'normal',
    sortDirection: orderBy === cellName ? order : false,
    colSpan: cell.colSpan || 1,
    sx: {},
  };

  if (cell.width) {
    tableCellProps.width = cell.width;
  }
  if (cell.filter) {
    tableCellProps.sx.textWrap = 'nowrap';
  }

  const tableSortLabelProps = {
    active: orderBy === cellName,
    direction: orderBy === cellName ? order : 'asc',
    onClick: createSortHandler(cellName),
  };
  const boxProps = {
    component: 'span',
    sx: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: '1px',
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      whiteSpace: 'nowrap',
      width: '1px',
    }, // visuallyHidden
  };
  const filterBtnProps = {
    // 'aria-describedby': 'table-head-popover',
    size: 'small',
    onClick: () => setOpen(true),
    sx: {
      color: 'white',
    },
  };
  const popoverProps = {
    // id: open ? filterBtnProps['aria-describedby'] : undefined,
    open,
    anchorEl: ref.current,
    onClose: () => {
      setFilter(value);
      // setOpen(false);
    },
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'left',
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left',
    },
  };
  const filterProps = {
    fullWidth: true,
    value,
    onChange: (event) => setValue(event.target.value),
    label: cell.label,
    variant: 'filled',
    InputProps: {
      endAdornment: (
        <InputAdornment position="end">
          {value.length > 0 && (
            <IconButton
              size="small"
              onClick={() => {
                setValue('');
                setFilter('');
                // setOpen(false);
              }}
            >
              <Close />
            </IconButton>
          )}
          <IconButton
            color="success"
            size="small"
            onClick={() => {
              setFilter(value);
              // setOpen(false);
            }}
          >
            <Check />
          </IconButton>
        </InputAdornment>
      ),
    },
  };

  return (
    <TableCell {...tableCellProps}>
      <Box ref={ref}>
        {cell.sort ? (
          <TableSortLabel {...tableSortLabelProps}>
            {cell.label}
            {orderBy === cellId
              ? (<Box {...boxProps}>{order === 'desc' ? 'sorted descending' : 'sorted ascending'}</Box>)
              : null}
          </TableSortLabel>
        ) : cell.label}
        {cell.filter ? (
          <>
            <IconButton {...filterBtnProps}>
              {filter ? (
                <Badge color="secondary" variant="dot"><FilterAlt sx={{ fontSize: 18 }} /></Badge>
              ) : (
                <FilterAlt sx={{ fontSize: 18 }} />
              )}
            </IconButton>
            <Popover {...popoverProps}>
              <TextField {...filterProps} />
            </Popover>
          </>
        ) : null}
      </Box>
    </TableCell>
  );
};

export default TableHeadCol;
